/** Which development tools are showing, remembered per browser. */
export type DevelopmentTool =
  | "tanstackDevtools"
  | "reactGrab"
  | "reactScan"
  | "viteDevtools"
  | "botChecks";

export type DevelopmentToolsVisibility = Record<DevelopmentTool, boolean>;

const STORAGE_KEY = "pax:development-tools";
const LAYOUT_VERSION_KEY = "pax:development-tools-layout";
const LAYOUT_VERSION = "2";

const DEFAULTS: DevelopmentToolsVisibility = {
  tanstackDevtools: false,
  reactGrab: false,
  reactScan: false,
  viteDevtools: false,
  botChecks: false,
};

/** Drop vendor UI state from the earlier hidden and embedded layout. */
export function migrateDevelopmentToolsLayout() {
  if (window.localStorage.getItem(LAYOUT_VERSION_KEY) === LAYOUT_VERSION) return;

  window.localStorage.removeItem("tanstack_devtools_settings");
  window.localStorage.removeItem("tanstack_devtools_state");
  window.localStorage.removeItem("devframes-dock-state");
  window.localStorage.setItem(LAYOUT_VERSION_KEY, LAYOUT_VERSION);
}

export function readDevelopmentToolsVisibility(): DevelopmentToolsVisibility {
  if (!import.meta.env.DEV) {
    return {
      tanstackDevtools: false,
      reactGrab: false,
      reactScan: false,
      viteDevtools: false,
      botChecks: false,
    };
  }
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? "{}");
    return { ...DEFAULTS, ...stored };
  } catch {
    return DEFAULTS;
  }
}

export function writeDevelopmentToolVisibility(tool: DevelopmentTool, visible: boolean) {
  const next = { ...readDevelopmentToolsVisibility(), [tool]: visible };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}
